module.exports = __webpack_public_path__ + "img/resource_pkg3.c71a96ef.png";